import { AccountingStatementInputDto } from '../../types';
import { InputBaseModel, NodeBaseModel } from '..';

export default class InputModel extends InputBaseModel {
    constructor(node: NodeBaseModel, data: AccountingStatementInputDto) {
        super(node, data);
    }
}
